import { render, staticRenderFns } from "./StartupDetailsPopover.vue?vue&type=template&id=6f0abaf0&"
import script from "./StartupDetailsPopover.vue?vue&type=script&lang=js&"
export * from "./StartupDetailsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports